import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import globalVariable from '../../../GlobalVariable';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <header className="fixed w-full bg-white shadow-md z-50">
            <div className="container mx-auto px-6 py-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        <Link to="/" className="text-2xl font-bold text-pink-600">
                            <img src={globalVariable.logo} alt="Azúcar Multimedia" className="h-12" />
                        </Link>
                    </div>

                    {/* Mobile menu button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="text-gray-800 focus:outline-none"
                        >
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                {isOpen ? (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                ) : (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                )}
                            </svg>
                        </button>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex space-x-8">
                        <Link to="/" className="text-gray-800 hover:text-red-600 font-medium">Home</Link>
                        <Link to="/services" className="text-gray-800 hover:text-red-600 font-medium">Services</Link>
                        {/* <Link to="/portfolio" className="text-gray-800 hover:text-red-600 font-medium">Portfolio</Link> */}
                        <Link to="/clients" className="text-gray-800 hover:text-red-600 font-medium">Clients</Link>
                        <Link to="/contact" className="text-gray-800 hover:text-red-600 font-medium">Contact</Link>
                        <Link to="/login" className="text-red-800 hover:text-red-600 font-medium">Login</Link>

                    </nav>
                </div>

                {/* Mobile Navigation */}
                {isOpen && (
                    <div className="md:hidden mt-4 pb-4">
                        <Link to="/" className="block py-2 text-gray-800 hover:text-red-600">Home</Link>
                        <Link to="/services" className="block py-2 text-gray-800 hover:text-red-600">Services</Link>
                        {/* <Link to="/portfolio" className="block py-2 text-gray-800 hover:text-red-600">Portfolio</Link> */}
                        <Link to="/clients" className="block py-2 text-gray-800 hover:text-red-600">Clients</Link>
                        <Link to="/contact" className="block py-2 text-gray-800 hover:text-red-600">Contact</Link>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;